import React from "react";
import useIsMobile from "../hooks/useIsMobile";
import AdminSimpleResourceMobile from "../mobile/admin/AdminSimpleResourceMobile";
import GestionModePaiement from "./GestionModePaiement";

export default function ResponsiveGestionModePaiement(props) {
  return useIsMobile() ? <AdminSimpleResourceMobile resource="paymentModes" {...props} /> : <GestionModePaiement {...props} />;
}
